
import _ from 'lodash';
import axios from 'axios';
import React, { Component}  from 'react';
import Button from '@material-ui/core/Button';
import { FormControl, FormHelperText } from '@material-ui/core';

import { FormContext } from 'core/FormProvider';
import { AsyncSelectWidget } from 'form/SelectAsync';
import { ContextWidget, ContextFormControlWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import FormGroup from 'form/FormGroup';
import { TariffPointIndividualForm } from './FormPointsIndividual';
import { AsyncAutocompleteMultipleWidget } from 'form/AutocompleteMultipleWidget';
import { CheckboxWidget } from 'form/Checkbox';
import VatWidget from "form/VatWidget";
import { AutocompleteMultipleWidget2 } from 'form/AutocompleteMultipleWidget2';
import TariffServicesForm from "./FormServices";
import qs from "qs";

export class TariffIndividualForm extends Component {

  static contextType = FormContext;

  constructor(props) {
    super(props);
    this.state = {
      points: []
    }
  }

  baseTariffOnChange = (context, item, itemObject) => {
    let values = {
      base_tariff: item
    }
    if (item) {
      values['name'] = itemObject.name;
      values['carrier'] = itemObject.carrier;
    }

    context.setContext('base_tariff', itemObject);
    context.setValues(values);
  };

  addPoint = (context) => {
    let { points } = this.state;
    points.push({});
    this.setState({
      points: points
    })
  };

  handlePointChange = (point, index) => {
    let { points } = this.state;
    points[index] = point;
    this.setState({
      points: points
    });
  };

  componentDidMount() {
    this.getPoints()
  }

  getPoints = () => {
    const { item } = this.props;
    const { tariff_points } = item;
    const pointsId = tariff_points.map(item => item.point);
    if (pointsId.length > 0) {
      axios.get('catalog/point', {
        params: {id: pointsId, page_size: 500},
        paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        },
      })
      .then(res => {
        this.setState({
          points: res.data.results
        })
      })
    }
  };

  getClientIds = (clients) => {
    let clientIds = [];
    clients.forEach(client => {
      clientIds.push(client.id);
    });
    return clientIds;
  };

  handleClientsChange = (context, clients) => {
    const clientIds = this.getClientIds(clients);
    const selectMultipleCounterparty = _.filter(
      context.item.counterparties,
        counterparty => clientIds.indexOf(counterparty.client) !== -1
    );

    context.setValue('clients', clients);
    context.setValue('counterparties', selectMultipleCounterparty);
  };

  handlePointDelete = (context, pointId) => {
    const point_services = _.filter(context.item.tariff_points, (obj) => obj.point === pointId);
    _.forEach(point_services, (point_service) => {
      const index = context.item.tariff_points.findIndex(
        o => o.service.id === point_service.service.id && o.point === pointId
      );
      if (point_service.id) {
        context.setValue(`tariff_points.${index}.cost`, 0);
        context.setValue(`tariff_points.${index}.is_delete`, true);
      }
      else {
        context.removeArrayValue(`tariff_points`, index);
      }
    });

    const index = this.state.points.findIndex(o => o.id === pointId);
    if (index !== -1) {
      let points = this.state.points;
      points.splice(index, 1);
      this.setState({
        points: points
      })
    }
  };

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;
          const points = this.state.points;

          return (
            <FormGroup>
              <ContextFormControlWidget
                name={'base_tariff'}
                label={'Базовый тариф'}
                required={true}
                WidgetComponent={AsyncSelectWidget}
                widgetProps={{
                  url: 'tariff',
                  label: 'Базовый тариф',
                  optionLabel: 'name',
                  filter: {
                    polymorphic_ctype__model: 'tariffbase'
                  },
                  onChange: (item, itemObject) => this.baseTariffOnChange(context, item, itemObject),
                  onLoaded: (itemObject) => context.setContext('base_tariff', itemObject)
                }}
              />

              <ContextWidget
                name={'name'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Название',
                  required: true
                }}
              />

              <ContextFormControlWidget
                label={'Перевозчик'}
                name={'carrier'}
                required={true}
                WidgetComponent={AsyncSelectWidget}
                widgetProps={{
                  disabled: true,
                  label: 'Перевозчик',
                  url: 'catalog/choice/?type=CARRIER'
                }}
              />

              <ContextFormControlWidget
                name={'vat'}
                label={'НДС'}
                WidgetComponent={VatWidget}
                widgetProps={{
                  label: 'НДС'
                }}
              />

              <div className={'mb-20'}>
                <AutocompleteMultipleWidget2
                  url={'client'}
                  label={'Клиенты'}
                  value={item.clients}
                  onChange={(options) => this.handleClientsChange(context, options)}
                />
              </div>

              {item.clients && item.clients.length > 0 && (
                <AsyncAutocompleteMultipleWidget
                  url={'client/counterparty'}
                  filter={{
                    client__in: this.getClientIds(item.clients)
                  }}
                  value={item.counterparties}
                  label={'Контрагенты'}
                  filterSelectedOptions={true}
                  showSelectAllOptionsButton={false}
                  onChange={(value) => context.setValue('counterparties', value)}
                />
              )}

              <div>
                <FormControl>
                  <CheckboxWidget
                    value={item.as_default}
                    onChange={(value) => context.setValue('as_default', value)}
                    label={'Тариф по умолчанию'}
                  />
                </FormControl>
              </div>

              <FormControl>
                <CheckboxWidget
                  value={item.is_active}
                  onChange={(value) => context.setValue('is_active', value)}
                  label={'Активность'}
                />
                <FormHelperText>При снятии галочки попадает в архив</FormHelperText>
              </FormControl>

              {item.base_tariff && (
                <>
                  <div className={'mb-40'}>
                    <TariffServicesForm />
                  </div>

                  {points.length === 0 && (
                    <h3>Точки с изменениями отсутствуют</h3>
                  )}

                  {points.length > 0 && (
                    <h3>Точки с изменениями {points.length}</h3>
                  )}

                  <div className={'w-700'}>
                  {points.map((point, index) =>
                    <TariffPointIndividualForm
                      key={index}
                      index={index}
                      context={context}
                      point={point}
                      onPointChange={this.handlePointChange}
                      onPointDelete={this.handlePointDelete}
                    />
                  )}
                  </div>

                  <div>
                    <Button
                      variant="outlined"
                      onClick={() => this.addPoint(context)}
                      >
                      + Добавить точку
                    </Button>
                  </div>
                </>
              )}

            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
